import styled from 'styled-components';

export const Container = styled.div`
  margin: 0;
  padding: 10px;
  background-color: #ddd;
  border-radius: 5px;
  .MuiAccordionSummary-root.Mui-expanded {
    min-height: 35px !important;
  }
  .MuiAccordionDetails-root {
    padding: 0px;
  }
  .MuiList-padding {
    padding-top: 0px;
    padding-bottom: 0px;
  }
  .MuiAccordionSummary-root:hover: {
    cursor: default !important;
  }
  .MuiButtonBase-root {
    cursor: ${props => (props.cursorType ? 'cursor' : 'default')};
    color: black;
  }
  .MuiListItem-root.Mui-disabled {
    opacity: 1;
  }  
`;

export const TitleContent = styled.div`
  margin: 0;
  width: 85%;
  min-height: 25px;
  margin-bottom: 10px;
`;

export const CreateButton = styled.span`
  margin-left: 0px;
  background: #bbd2ca;
  border: none;
  font-size: 0.875rem;
  font-weight: 400;
  border-radius: 15px;
  padding: 5px 10px 5px 10px;
  cursor: pointer;
`;

export const GroupCreateButton = styled.span`
  margin-left: 20px;
  background: #eee;
  border: none;
  font-size: 0.875rem;
  font-weight: 400;
  border-radius: 15px;
  padding: 5px 10px 5px 10px;
  cursor: pointer;
`;

export const MassinveImportButton = styled.span`
margin-left: 20px;
display: flex;
padding: 3px 12px !important;
justify-content: center;
align-items: center;
background: #eee;
border: none;
font-size: 0.875rem;
font-weight: 400;
border-radius: 15px;
padding: 5px 10px 5px 10px;
cursor: pointer;
`;

export const DeleteChecklistButton = styled.span`
  position: absolute;
  right: 20px;
  display: flex;
  padding: 3px 12px !important;
  justify-ontent: center;
  align-items: center;
  position: 'absolute';
  right: 16px;
  margin-left: 20px;
  background: #eee;
  border: none;
  font-size: 0.875rem;
  font-weight: 400;
  border-radius: 15px;
  padding: 5px 10px 5px 10px;
  cursor: pointer;
`;

export const EditButton = styled.div`
  position: absolute;
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
  right: 30px;
  top: 0px;
  cursor: pointer;
`;

export const DeleteButton = styled.div`
  position: absolute;
  right: 0px;
  top: 0px;
  cursor: pointer;
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
`;
